// extracted by mini-css-extract-plugin
export default {"mobile-nav":"MobileNav_mobile-nav__nrb6e","icon":"MobileNav_icon__hgm87"};